import { render, staticRenderFns } from "./TemplatesCollection.vue?vue&type=template&id=3800f45e&"
import script from "./TemplatesCollection.vue?vue&type=script&lang=ts&"
export * from "./TemplatesCollection.vue?vue&type=script&lang=ts&"
import style0 from "./TemplatesCollection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports